import { z } from "zod";
import { SimpleVaultCredentialKindSchema } from "./vault-credential-values";

/** Model-facing metadata only. Secret values must never be tool arguments or results. */
export const SecretRequestSchema = z
  .object({
    name: z.string().min(1).max(240),
    kind: SimpleVaultCredentialKindSchema,
  })
  .strict();
export type SecretRequest = z.infer<typeof SecretRequestSchema>;

export const SecretRequestResultSchema = z.discriminatedUnion("status", [
  z
    .object({ status: z.literal("saved"), credential_id: z.string().regex(/^vlc_[a-f0-9]{24}$/) })
    .strict(),
  z.object({ status: z.literal("cancelled") }).strict(),
]);
export type SecretRequestResult = z.infer<typeof SecretRequestResultSchema>;
